import type { FetchHooks } from 'ofetch'

import type { Owner } from '@backmarket/nuxt-module-logger/types'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

/**
 * A reusable composable that provides logging hooks for oFetch supporting fetchers.
 * Currently used by Algolia recommendations.
 * This could potentially be added to @backmarket/nuxt-module-http-v2 and made consumable for other teams.
 */
export function useHttpFetchLoggers(): FetchHooks {
  const owners: Owner[] = ['bot-squad-search-and-recommendation-front']
  const logger = useLogger()
  let startTime: number
  let endpoint: RequestInfo

  return {
    onRequest({ request }) {
      startTime = performance.now()
      endpoint = request
    },
    onResponse({ response, options }) {
      if (!response.ok) return

      logger.info(`[SUCCESS] ${options.method} ${endpoint}`, {
        type: 'API_REQUEST_SUCCESS',
        elapsedTime: Math.floor(performance.now() - startTime),
        statusCode: response.status,
        owners,
      })
    },
    onResponseError({ response, error, options }) {
      logger.error(`[FAIL] ${options.method} ${endpoint}`, {
        type: 'API_REQUEST_FAIL',
        elapsedTime: Math.floor(performance.now() - startTime),
        statusCode: response.status,
        error,
        owners,
      })
    },
  }
}
